import {
  EditSection as SharedEditSection,
  type EditSectionProps,
} from '../../../shared/EditSection';

import { LockedPill } from './LockedPill';

/** The shared edit section, marked "Locked" for viewers who cannot edit this venue. */
export function EditSection(props: Omit<EditSectionProps, 'action'>) {
  return <SharedEditSection {...props} action={props.readOnly && <LockedPill />} />;
}
